<template>
	<div class="tab-content">
		<form class="register-form" @submit.prevent="$emit('register', registerForm)">
			<div class="form-group">
				<label class="form-label">手机号码</label>
				<div class="input-group">
					<input type="tel" class="form-input" placeholder="请输入手机号码" v-model="registerForm.phone" required
						@input="validatePhone">
					<i class="el-icon-phone input-icon"></i>
				</div>
				<div class="error-message" v-if="errors.phone">{{ errors.phone }}</div>
			</div>

			<div class="form-group">
				<label class="form-label">验证码</label>
				<div class="code-group">
					<div class="input-group code-input">
						<input type="text" class="form-input" placeholder="请输入验证码" v-model="registerForm.code" required
							maxlength="6" @input="validateCode">
						<i class="el-icon-circle-check input-icon"></i>
					</div>
					<button type="button" class="code-btn" :disabled="codeCountdown > 0 || !!errors.phone"
						@click="sendVerificationCode">
						{{ codeCountdown > 0 ? `${codeCountdown}秒后重试` : '获取验证码' }}
					</button>
				</div>
				<div class="error-message" v-if="errors.code">{{ errors.code }}</div>
			</div>

			<div class="form-group">
				<label class="form-label">设置密码</label>
				<div class="input-group">
					<input type="password" class="form-input" placeholder="请设置登录密码" v-model="registerForm.password"
						required @input="validatePassword">
					<i class="el-icon-lock input-icon"></i>
				</div>
				<div class="error-message" v-if="errors.password">{{ errors.password }}</div>
			</div>

			<div class="form-group">
				<label class="form-label">确认密码</label>
				<div class="input-group">
					<input type="password" class="form-input" placeholder="请再次输入密码"
						v-model="registerForm.confirmPassword" required @input="validateConfirmPassword">
					<i class="el-icon-lock input-icon"></i>
				</div>
				<div class="error-message" v-if="errors.confirmPassword">
					{{ errors.confirmPassword }}
				</div>
			</div>

			<div class="form-group">
				<label class="form-label">邀请码 <span class="optional">(选填)</span></label>
				<div class="input-group">
					<input type="text" class="form-input" placeholder="请输入邀请码" v-model="registerForm.invite_code"
						maxlength="8">
					<i class="el-icon-goods input-icon"></i>
				</div>
			</div>

			<button type="submit" class="btn btn-primary" :disabled="!isFormValid || loading">
				<span v-if="loading" class="loading-spinner"></span>
				{{ loading ? '注册中...' : '立即注册' }}
			</button>
		</form>
	</div>
</template>

<script>
	export default {
		name: 'RegisterForm',
		props: {
			loading: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				registerForm: {
					phone: '',
					code: '',
					password: '',
					confirmPassword: '',
					invite_code: ''
				},
				errors: {
					phone: '',
					code: '',
					password: '',
					confirmPassword: ''
				},
				codeCountdown: 0
			}
		},
		computed: {
			isFormValid() {
				return (
					this.registerForm.phone &&
					this.registerForm.code &&
					this.registerForm.password &&
					this.registerForm.confirmPassword &&
					!this.errors.phone &&
					!this.errors.code &&
					!this.errors.password &&
					!this.errors.confirmPassword
				)
			}
		},
		methods: {
			validatePhone() {
				const phoneRegex = /^1[3-9]\d{9}$/
				if (!this.registerForm.phone) {
					this.errors.phone = '请输入手机号码'
				} else if (!phoneRegex.test(this.registerForm.phone)) {
					this.errors.phone = '手机号码格式不正确'
				} else {
					this.errors.phone = ''
				}
			},
			validateCode() {
				if (!this.registerForm.code) {
					this.errors.code = '请输入验证码'
				} else if (this.registerForm.code.length !== 6) {
					this.errors.code = '验证码应为6位数字'
				} else {
					this.errors.code = ''
				}
			},
			validatePassword() {
				if (!this.registerForm.password) {
					this.errors.password = '请输入密码'
				} else if (this.registerForm.password.length < 6) {
					this.errors.password = '密码长度至少6位'
				} else {
					this.errors.password = ''
				}
				// 如果确认密码已输入，需要重新验证
				if (this.registerForm.confirmPassword) {
					this.validateConfirmPassword()
				}
			},
			validateConfirmPassword() {
				if (!this.registerForm.confirmPassword) {
					this.errors.confirmPassword = '请确认密码'
				} else if (this.registerForm.password !== this.registerForm.confirmPassword) {
					this.errors.confirmPassword = '两次输入的密码不一致'
				} else {
					this.errors.confirmPassword = ''
				}
			},
			sendVerificationCode() {
				this.validatePhone()
				if (this.errors.phone) {
					return
				}

				// 触发父组件的发送验证码事件
				this.$emit('send-code', this.registerForm.phone)

				// 开始倒计时
				this.codeCountdown = 60
				const timer = setInterval(() => {
					this.codeCountdown--
					if (this.codeCountdown <= 0) {
						clearInterval(timer)
					}
				}, 1000)
			},
			resetForm() {
				this.registerForm = {
					phone: '',
					code: '',
					password: '',
					confirmPassword: '',
					invite_code: ''
				}
				this.errors = {
					phone: '',
					code: '',
					password: '',
					confirmPassword: ''
				}
				this.codeCountdown = 0
			}
		},
		watch: {
			loading(newVal) {
				if (!newVal) {
					// 注册成功后可以重置表单
				}
			}
		}
	}
</script>

<style scoped>
	/* 保留原有的样式 */
	.form-group {
		margin-bottom: 16px;
	}

	.form-label {
		display: block;
		margin-bottom: 6px;
		font-size: 13px;
		color: #666;
		font-weight: 500;
	}

	.input-group {
		position: relative;
	}

	.form-input {
		width: 100%;
		padding: 12px 14px;
		border: 1px solid #e0e0e0;
		border-radius: 8px;
		font-size: 14px;
		color: #333;
		transition: all 0.3s ease;
		background: #fafafa;
	}

	.form-input:focus {
		outline: none;
		border-color: #2280FD;
		background: white;
		box-shadow: 0 0 0 3px rgba(34, 128, 253, 0.1);
	}

	.input-icon {
		position: absolute;
		right: 14px;
		top: 50%;
		transform: translateY(-50%);
		color: #999;
		font-size: 14px;
	}

	.error-message {
		color: #ff4d4f;
		font-size: 12px;
		margin-top: 4px;
		height: 16px;
	}

	.code-group {
		display: flex;
		gap: 10px;
	}

	.code-input {
		flex: 1;
	}

	.code-btn {
		padding: 0 16px;
		background: #f0f0f0;
		border: 1px solid #e0e0e0;
		border-radius: 8px;
		color: #666;
		cursor: pointer;
		transition: all 0.3s ease;
		white-space: nowrap;
		font-size: 13px;
	}

	.code-btn:hover:not(:disabled) {
		background: #e5e5e5;
	}

	.code-btn:disabled {
		background: #f5f5f5;
		color: #ccc;
		cursor: not-allowed;
	}

	.btn {
		width: 100%;
		padding: 12px;
		border: none;
		border-radius: 8px;
		font-size: 14px;
		font-weight: 500;
		cursor: pointer;
		transition: all 0.3s ease;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 6px;
		position: relative;
	}

	.btn:disabled {
		opacity: 0.6;
		cursor: not-allowed;
		transform: none !important;
		box-shadow: none !important;
	}

	.btn-primary {
		background: #2280FD;
		color: white;
		box-shadow: 0 3px 10px rgba(34, 128, 253, 0.3);
	}

	.btn-primary:hover:not(:disabled) {
		background: #1a6fd0;
		transform: translateY(-1px);
		box-shadow: 0 5px 15px rgba(34, 128, 253, 0.4);
	}

	.btn-primary:active:not(:disabled) {
		transform: translateY(0);
	}

	.loading-spinner {
		width: 16px;
		height: 16px;
		border: 2px solid rgba(255, 255, 255, 0.3);
		border-radius: 50%;
		border-top-color: white;
		animation: spin 1s ease-in-out infinite;
	}

	.optional {
		color: #999;
		font-weight: normal;
	}

	@keyframes spin {
		to {
			transform: rotate(360deg);
		}
	}
</style>